module.exports = __webpack_public_path__ + "img/google.e9612850.png";